<div class="card">
	<div class="p-grid">
		<div class="p-col-12 p-lg-4 d-flex flex-column">
			<div>
				<img src="../../../../../assets/images/ubereats.jpg" class="img-fluid" />
			</div>
			<div class="btn btn-primary" *ngIf="!venueSvc.getIntegration('uber')" (click)="uberConnect()">Connect</div>
			<div class="btn btn-primary my-3" *ngIf="venueSvc.getIntegration('uber')" (click)="uberConnect()">Reconnect</div>
			<div>
				<div class="p-grid">
					<div class="p-col">Status:</div>
					<div class="p-col">
						<span *ngIf="!venueSvc.getIntegration('uber')">Disconnected</span>
						<span *ngIf="venueSvc.getIntegration('uber') && venueSvc.getIntegration('uber').status">Connected</span>
						<span *ngIf="venueSvc.getIntegration('uber') && !venueSvc.getIntegration('uber').status">Expired</span>
					</div>
				</div>
				<div class="p-grid" *ngIf="venueSvc.getIntegration('uber')?.expirationDateTime">
					<div class="p-col">Expires:</div>
					<div class="p-col">
						{{ app.moment(venueSvc.getIntegration('uber')?.expirationDateTime).format('l LT') }}
					</div>
				</div>
			</div>
			<div *ngIf="(venueSvc.getIntegration('uber')?.status && uber.stores) || uberUnauthorized">
				<ng-container *ngIf="!venueSvc.ooVenue.uberStoreId || uberUnauthorized">
					<div class="mt-3">Uber Stores</div>
					<p-dropdown [(ngModel)]="uberStoreId" [options]="uber.stores" [autoDisplayFirst]="false" [style]="{ width: '100%' }"> </p-dropdown>
					<div class="btn btn-primary w-100 mt-3" [ladda]="loadingUber" (click)="uberLinkStore(uberStoreId)">Link Store</div>
				</ng-container>
			</div>
			<p-button
				*ngIf="venueSvc.getIntegration('uber')?.status"
				pRipple
				styleClass="p-button-raised p-button-danger mt-3 w-100"
				label="Remove Integration"
				(click)="uberDelete()"
			>
			</p-button>
		</div>
		<div class="p-col-12 p-lg-4 d-flex flex-column">
			<ng-container *ngIf="venueSvc.ooVenue.uberStoreId">
				<div class="mt-3">Menu Item Price Number</div>
				<p-dropdown
					[(ngModel)]="venueSvc.ooVenue.uberPriceNumber"
					[options]="venueSvc.priceNumbers"
					[autoDisplayFirst]="false"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div class="mt-3">Mod Price Number</div>
				<p-dropdown
					[(ngModel)]="venueSvc.ooVenue.uberPriceModNumber"
					[options]="venueSvc.priceNumbers"
					[autoDisplayFirst]="false"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div class="mt-3">Uber Menu</div>
				<p-dropdown
					placeholder="Default menu"
					[(ngModel)]="venueSvc.ooVenue.uberOOMenuKey"
					[options]="venueSvc.ooMenus"
					optionLabel="name"
					optionValue="key"
					[style]="{ width: '100%' }"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<div
					class="btn btn-primary w-100 mt-3"
					[disabled]="!uberStoreId || !venueSvc.getIntegration('uber') || uberUnauthorized"
					[ladda]="loadingUber"
					(click)="uploadUberMenu()"
				>
					Sync Menu
				</div>
			</ng-container>
		</div>
		<div class="p-col-12 p-lg-4 d-flex flex-column">
			<div *ngIf="uberStatus && uberStatus.error">
				<p-button pRipple *ngIf="uberStoreId" styleClass="p-button-raised m-2" (click)="uberLinkStore(uberStoreId)">
					<ng-template pTemplate="content">
						<div class="text-center"><fa-icon [icon]="['far', 'uber']" size="lg" class="ms-1"></fa-icon> Link Focus to Uber</div>
					</ng-template>
				</p-button>
			</div>
			<div>
				<div class="d-flex flex-row">
					<div class="h4">Status</div>
				</div>
				<div class="p-grid">
					<div class="col-9">Store:</div>
					<div class="col-3">
						<p-skeleton *ngIf="!uberStatus"></p-skeleton>
						<fa-icon *ngIf="uberStatus && uberStatus.storeStatus.status === 'ONLINE'" [icon]="['far', 'check']" class="m-2"> </fa-icon>
						<fa-icon *ngIf="uberStatus && uberStatus.storeStatus.status !== 'ONLINE'" [icon]="['far', 'times']" class="m-2"> </fa-icon>
					</div>
				</div>
				<div *ngIf="uberStatus && uberStatus.storeStatus.status !== 'ONLINE' && uberStatus.storeStatus.offlineReason" class="p-grid">
					<div class="p-col">
						<i>Offline reason</i>
					</div>
					<div class="p-col" style="text-align: right">
						<i>{{ uberStatus.storeStatus.offlineReason }}</i>
					</div>
				</div>
				<div class="p-grid">
					<div class="col-9">Focus Integration:</div>
					<div class="col-3">
						<p-skeleton *ngIf="!uberStatus"></p-skeleton>
						<fa-icon
							*ngIf="uberStatus && uberStatus.posStatus && uberStatus.posStatus.pos_integration_enabled"
							[icon]="['far', 'check']"
							class="m-2"
						>
						</fa-icon>
						<fa-icon
							*ngIf="uberStatus && uberStatus.posStatus && !uberStatus.posStatus.pos_integration_enabled"
							[icon]="['far', 'times']"
							class="m-2"
						>
						</fa-icon>
					</div>
				</div>
				<div class="p-grid">
					<div class="col-9">Order Release Enabled:</div>
					<div class="col-3">
						<p-skeleton *ngIf="!uberStatus"></p-skeleton>
						<fa-icon *ngIf="uberStatus && uberStatus.posStatus && uberStatus.posStatus.order_release_enabled" [icon]="['far', 'check']" class="m-2">
						</fa-icon>
						<fa-icon
							*ngIf="uberStatus && uberStatus.posStatus && !uberStatus.posStatus.order_release_enabled"
							[icon]="['far', 'times']"
							class="m-2"
						>
						</fa-icon>
					</div>
				</div>
				<div class="p-grid">
					<div class="col-9">Auto Accept Enabled:</div>
					<div class="col-3">
						<p-skeleton *ngIf="!uberStatus"></p-skeleton>
						<fa-icon *ngIf="uberStatus && uberStatus.posStatus && uberStatus.posStatus.auto_accept_enabled" [icon]="['far', 'check']" class="m-2">
						</fa-icon>
						<fa-icon *ngIf="uberStatus && uberStatus.posStatus && !uberStatus.posStatus.auto_accept_enabled" [icon]="['far', 'times']" class="m-2">
						</fa-icon>
					</div>
				</div>
				<div>Uber Store ID:</div>
				<div>
					<p-skeleton *ngIf="!uberStatus"></p-skeleton>
					<span *ngIf="uberStatus && uberStatus.posStatus">
						{{ uberStatus?.posStatus.store_id }}
					</span>
				</div>
			</div>
		</div>
	</div>
	<app-integration-ubereats-request-list></app-integration-ubereats-request-list>
</div>
